module.exports = __webpack_public_path__ + "fonts/8b56391.woff2";